import styled, {keyframes} from 'styled-components';
import {defaultTheme} from '@stencil/build-theme';
import RightDoubleArrowIcon from '../../../../../stories/Icons/RightDoubleArrow';
import {CenteredSpaceWrap} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

import HappyDoubleArrowIcon from '@stencil/icons/src/HappyDoubleArrowIcon/HappyDoubleArrowIcon';

export const TabLocationSearchWrapper = styled.div(
  props => `
  display:flex;
  max-width:120rem;
  width:100%;
  height: ${props.heightStyle};
  overflow:${props.overflow};
  margin:${props.marginStyle};
  transition: all .3s ease-in-out ;
`,
);

export const QuickFiltersAndSortingOuterWrap = styled.div(
  props => `
  transition: all .3s ease-in-out ;
  background-color: ${props.theme.colors.goWhite.base};
  box-shadow: 0 .8rem .6rem -.6rem ${props.theme.colors.shadow.light};
`,
);

export const QuickFiltersAndSortingWrapper = styled.div(
  props => `
  display:flex;
  align-items:center;
  padding: ${props.theme.spacing.small} 0;
  max-width: 120rem; 
  margin: 0 auto; 
`,
);

export const QuickFiltersWrapper = styled.div`
  display: flex;
  width: 65%;
`;

export const RightDoubleArrowOuterWrap = styled.div(
  props => `
  background: ${props.backgroundStyle};
  background:white;
  transition: background .3s linear;
  border-radius: ${props.theme.misc.borderRadius.custom(90)};
  border-radius: 50%;
  position: absolute;
  bottom: -1.5rem;
  width: 9rem;
  height: 5rem;
  box-shadow: 0 .8rem .6rem -.6rem ${props.theme.colors.shadow.light};
  left: 50%;
  cursor:pointer;

`,
);

export const RightDoubleArrowIconWrap = styled(HappyDoubleArrowIcon)(
  props => `
  position: absolute;
  top: 2.5rem;
  left: 3.5rem;
  transform: ${props.transformStyle};
  transition: transform 0.1s ease 0s;
`,
);

export const LocationAndSortByOuterWrap = styled(CenteredSpaceWrap)(
  props => `
  width: 35%;
  @media (min-width: 768px) and (max-width: 1024px) {
    display: flex;
    flex-direction: column;
  } 
`,
);

/*** shimmer loader for quick filter */

const placeHolderShimmer = keyframes`
  0% {
    background-position: -46.8rem 0;
  }
  
  100% {
    background-position: 46.8rem 0; 
  }
`;

export const contentLoader = styled.div`
  background: ${props => props.theme.colors.goBrandBlue.medium};
  background-image: linear-gradient(to right, #d1e5ff 0%, #e2efff 20%, #d1e5ff 40%, #d1e5ff 100%);
  background-size: 50rem 3.8rem;
  animation-name: ${placeHolderShimmer};
  animation-fill-mode: forwards;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  border-radius: ${props => props.theme.misc.borderRadius.small};
`;

export const QuickLocationLoader = styled(contentLoader)(
  props => `
  width:9.5rem;
  height:3.2rem;
  border-radius:${props.theme.misc.borderRadius.xlarge};
  margin-right:${props.theme.spacing.custom(12)}
`,
);

export const SearchInput = styled.input(
  props => `
  display: block;
  width: 100%;
  padding-left: ${props.theme.spacing.base};
  border:none;
  height: 3.5rem;
  background: ${props.theme.colors.goBrandBlue.light};
  &:focus {
    box-shadow: none;
    outline: none;
  }
  &::-webkit-input-placeholder{
    color: ${props.theme.colors.downriver.dark};
    font-weight:400;
  }
`,
);

export const InputWrapper = styled.input(
  props => `
  display: flex;
  flex-wrap: column;
  width: 100%;
  background-color: ${props.theme.colors.goWhite.base};
  padding: 0 ${props.theme.spacing.base};
  border-radius: ${props.theme.misc.borderRadius.xlarge};
  flex-direction: row;
  align-items: center;
  position: relative;
  border-radius: ${props.theme.misc.borderRadius.xlarge};
  border: .1rem solid ${props.theme.colors.goBrandBlue.light};
  background: ${props.theme.colors.goBrandBlue.light};
`,
);
